import { render, staticRenderFns } from "./agePie.vue?vue&type=template&id=2d6e95a5&scoped=true"
import script from "./agePie.vue?vue&type=script&lang=js"
export * from "./agePie.vue?vue&type=script&lang=js"
import style0 from "./agePie.vue?vue&type=style&index=0&id=2d6e95a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e95a5",
  null
  
)

export default component.exports